import {
  createStyles,
  Theme,
  withStyles,
  WithStyles
} from '@material-ui/core';
import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { InjectedIntlProps, injectIntl } from 'react-intl';

import { IAddTrainingStore } from './AddTrainingStore';

import { IDiaryPageStore } from '../../DiaryPageStore';

import {
  Button,
  CardActions,
  FormControl,
  Grid,
  InputAdornment,
  InputLabel,
  Select,
  TextField,
  Typography
} from '@material-ui/core';
import Slider from '@material-ui/lab/Slider';

import { ICameraStore } from '../../../components/camera/CameraStore';
import { IRouteStore } from '../../../RouteStore';


const styles = (theme: Theme) => createStyles({
  actions: {
    alignContent: 'center',
    display: 'flex',
  },
  button: {
    margin: 'auto'
  }
});

declare type stylesKeys = 'actions' | 'button';

interface IAddTrainingViewProps extends InjectedIntlProps {
  addTraining: IAddTrainingStore;
  camera: ICameraStore;
  diaryPage: IDiaryPageStore;
  routes: IRouteStore;
}

@observer
class AddTrainingView extends React.Component<IAddTrainingViewProps & WithStyles<stylesKeys>, {}> {

  public render() {
    const { addTraining, classes, intl: { formatMessage } } = this.props;

    return <React.Fragment>
        <Typography variant="h6" gutterBottom={true}>
          {formatMessage({id: 'diary.activity.add.title'})}
        </Typography>
        <Grid container={true} spacing={24}>
          <Grid item={true} xs={6} sm={6}>
            <TextField
              id="date"
              label={formatMessage({id: 'diary.activity.add.form.date'})}
              type="date"
              value={addTraining.date}
              fullWidth={true}
              onChange={this.onDateChange}
            />
          </Grid>
          <Grid item={true} xs={6} sm={6}>
            <TextField
              id="time"
              label={formatMessage({id: 'diary.activity.add.form.time'})}
              type="time"
              value={addTraining.time}
              fullWidth={true}
              onChange={this.onTimeChange}
            />
          </Grid>
          <Grid item={true} xs={12} sm={12}>
            <FormControl fullWidth={true}>
              <InputLabel htmlFor="age-native-simple">{formatMessage({id: 'diary.activity.add.form.type'})}</InputLabel>
              <Select
                native={true}
                value={addTraining.type}
                onChange={this.onTypeChange}
                fullWidth={true}
                inputProps={{
                  id: 'age-native-simple',
                  name: 'age',
                }}
              >
                <option value="" />
                {addTraining.types.map((t: any) => <option key={t} value={t}>{formatMessage({id: `diary.activity.add.form.type.${t}`})}</option>)}
              </Select>
            </FormControl>
          </Grid>
          <Grid item={true} xs={12} sm={12}>
            <TextField
              required={false}
              id="duration"
              name="duration"
              label={formatMessage({id: 'diary.activity.add.form.duration'})}
              fullWidth={true}
              value={addTraining.duration || ''}
              onChange={this.onDurationChange}
              type="number"
              InputProps={{
                endAdornment: <InputAdornment position="end">min</InputAdornment>,
              }}
            />
          </Grid>
          <Grid item={true} xs={12} sm={12}>
            <Typography>{formatMessage({id: 'diary.activity.add.form.intensity'})}</Typography>
            <Slider
              value={addTraining.intensity}
              min={0}
              max={10}
              step={1}
              onChange={this.onIntensityChange}
            />
          </Grid>
          <Grid item={true} xs={12} sm={12}>
            <TextField
              required={true}
              id="description"
              name="description"
              label={formatMessage({id: 'diary.activity.add.form.description'})}
              fullWidth={true}
              multiline={true}
              value={addTraining.description}
              onChange={this.onDescriptionChange}
              rows={5}
              rowsMax={10}
            />
          </Grid>
        </Grid>
        <CardActions className={classes.actions} disableActionSpacing={true}>
          <Button aria-label="Photo" variant="contained" className={classes.button} onClick={this.cancel}>
            Cancel
          </Button>
          <Button aria-label="Photo" variant="contained" color="secondary" disabled={!addTraining.valid} className={classes.button} onClick={this.submit}>
            Add
          </Button>
        </CardActions>
      </React.Fragment>;
}

  private onDateChange = (event: any) => {
    const { addTraining } = this.props;
    if (event && event.target && event.target.value) {
      addTraining.setDate(event.target.value);
    }
  }

  private onTimeChange = (event: any) => {
    const { addTraining } = this.props;
    if (event && event.target && event.target.value) {
      addTraining.setTime(event.target.value);
    }
  }

  private onDurationChange = (event: any) => {
    const { addTraining } = this.props;
    if (event && event.target) {
      addTraining.setDuration(event.target.value);
    }
  }

  private onTypeChange = (event: any) => {
    const { addTraining } = this.props;
    if (event && event.target) {
      addTraining.setType(event.target.value);
    }
  }

  private onIntensityChange = (event: any, value: any) => {
    const { addTraining } = this.props;
    window.console.log('add new activity', event, value);
    addTraining.setIntensity(value);
  }


  private onDescriptionChange = (event: any) => {
    const { addTraining } = this.props;
    if (event && event.target) {
      addTraining.setDescription(event.target.value);
    }
  }

  private submit = () => {
    const { addTraining, diaryPage, routes } = this.props;
    addTraining.submit()
      .then(() => {
        diaryPage.setDate(addTraining.getDate());
        routes.navigate('diary');
      });
  }

  private cancel = () => {
    const { routes } = this.props;
    routes.navigate('diary');
  }

}

export default withStyles<stylesKeys>(styles)(injectIntl<WithStyles<stylesKeys> & InjectedIntlProps>(inject('addTraining', 'diaryPage', 'routes')(AddTrainingView)));



// WEBPACK FOOTER //
// ./src/diary/training/add/AddTrainingView.tsx